import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

//Clases
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.codigoClaseServ}</td>
      <td className=''>{elemento.descrClaseServ}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfClase2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a25010101 = autorizacUA.findIndex( autorizac => autorizac === "25010101" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Clases" btnNuevo={a25010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '20%'}}>Código</th>
                <th className='' style={{width: '80%'}}>Descripción</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List> 
    </div>
  )
};

export default ConfClase2
